<template lang="pug">
v-list
  v-list-item
    v-list-item-icon: v-icon mdi-file-document
    v-list-item-content
      v-list-item-title {{ info.number }}
      v-list-item-subtitle Номер договора
  v-list-item(
    v-if="info.full_name"
  )
    v-list-item-icon: v-icon mdi-account
    v-list-item-content
      v-list-item-title {{ info.full_name }}
      v-list-item-subtitle ФИО
  v-list-item(
    v-if="info.email"
  )
    v-list-item-icon: v-icon mdi-email
    v-list-item-content
      v-list-item-title {{ info.email }}
      v-list-item-subtitle Почта
  v-list-item(
    v-if="info.address"
  )
    v-list-item-icon: v-icon mdi-home
    v-list-item-content
      v-list-item-title {{ info.address }}
      v-list-item-subtitle Адрес
  v-list-item(
    v-if="info.phone"
  )
    v-list-item-icon: v-icon mdi-phone
    v-list-item-content
      v-list-item-title {{ info.phone }}
      v-list-item-subtitle Телефон

  v-list-item(
    v-if="info.telegram"
    link
    :href="`https://t.me/${info.telegram.telegram_username}`"
    target="_blank"
  )
    v-list-item-icon: v-icon(color="primary") $telegram
    v-list-item-content
      v-list-item-title {{ info.telegram.telegram_username }}
      v-list-item-subtitle Telegram

</template>
<script>
export default {
  props: {
    info: { type: Object, required: true },
  },
};
</script>
